export const ACCEPT_ORDER_ACTIONS = {
  ACCEPT_ORDER: 'ACCEPT_ORDER',
  ACCEPT_WITHOUT_ORDER: 'ACCEPT_WITHOUT_ORDER',
} as const;
